import type { AlgoliaProductType } from '@integration-layer/components/Algolia/AlgoliaAisInfiniteHits.props'

/**
 * Represents the unique size label used for products.
 * @constant
 * @type {string}
 */
export const UNIQUE_SIZE_LABEL = 'TU'

/**
 * Retrieves the unique size label for a product if it exists.
 *
 * This function checks if the first size in the product's size array
 * matches the UNIQUE_SIZE_LABEL ('TU').
 *
 * @param {AlgoliaProductType} product - The Algolia product object to check.
 * @returns {string | undefined} The unique size label if it exists, otherwise undefined.
 *
 * @example
 * // Returns 'TU' if the product has a unique size
 * getUniqueSizeProductLabel({ size: [{ label: 'TU' }] })
 *
 * @example
 * // Returns undefined if no unique size is found
 * getUniqueSizeProductLabel({ size: [{ label: 'M' }] })
 */
export const getUniqueSizeProductLabel = (product: AlgoliaProductType) => {
  if (
    product?.size?.[0]?.label &&
    product?.size?.[0]?.label === UNIQUE_SIZE_LABEL
  )
    return product.size[0].label
}
